<div class="loading">
  <!-- <img src="assets/img/loading.gif" alt="loading"> -->
  <div class="blank-layout-container justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
</div>
